export const nowYYYYMMDD = (): string => new Date().toISOString().slice(0, 10);
export const nowYYYYMMDDhhmm = (): string =>
	new Date().toISOString().slice(0, 10) +
	" " +
	new Date().toISOString().split("T")[1].slice(0, 5);

export const nowYYYYMMDDhhmmss = (): string =>
	new Date().toISOString().slice(0, 10) +
	" " +
	new Date().toISOString().split("T")[1].slice(0, 8);

export const nowYY = (): string => new Date().toISOString().slice(2, 4);
export const nowYYYY = (): string => new Date().toISOString().slice(0, 4);

export const now = (): Date => new Date(nowYYYYMMDD());
export const yesterday = (): Date => {
	const yesterdayDate = new Date();
	yesterdayDate.setDate(yesterdayDate.getDate() - 1);
	return yesterdayDate;
};

export const addMonths = (date: Date, months: number): Date => {
	return new Date(date.setMonth(date.getMonth() + months));
};

export const afterOrEqualToday = (date: Date): boolean => {
	const justNow = now();

	if (justNow.getTime() <= date.getTime()) return true;

	return false;
};

export const beforeOrEqualToday = (date: Date): boolean => {
	const justNow = now();

	if (justNow.getTime() >= date.getTime()) return true;

	return false;
};

export const dateToYYYYMMDD = (date: Date): string =>
	date.toISOString().slice(0, 10);
export const dateToHHMM = (date: Date): string =>
	date.toISOString().slice(11, 16);
export const dateWithTimeZoneToYYYYMMDD = (date: Date): string => {
	const month = (date.getMonth() + 1).toString().padStart(2, "0");
	const day = date.getDate().toString().padStart(2, "0");
	return `${date.getFullYear()}-${month}-${day}`;
};
export const dateWithTimeZoneToHHMM = (date: Date): string =>
	date.toTimeString().slice(0, 5);
export const toDate = (date: string): Date => new Date(date);

const LOCAL_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

export const asUtc = (date: string): string =>
	LOCAL_DATE_TIME.test(date) ? `${date}Z` : date;

export const infiniteYYYYMMDD = (): string => {
	const date = now();
	date.setFullYear(date.getFullYear() + 1000);
	return dateToYYYYMMDD(date);
};

export const dateToYYYYMMDDHHMM = (date: Date): string => {
	const yyyyMMdd = dateWithTimeZoneToYYYYMMDD(date);
	const hhmm = dateWithTimeZoneToHHMM(date);

	return `${yyyyMMdd} ${hhmm}`;
};

export const dateToDDMMYYYY = (date: Date): string => {
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	return `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
};

export const fullYear = (): string => now().getFullYear().toString();

export const dateToAge = (dateParam: Date): number => {
	const date = new Date(dateParam);
	const differenceSeconds: number = Date.now() - date.getTime();
	return Math.floor(differenceSeconds / (1000 * 60 * 60 * 24 * 365.25));
};

export const birthdateFromAge = (age: number): Date => {
	const today = now();
	const birthYear = today.getFullYear() - age;
	return new Date(birthYear, today.getMonth(), today.getDate());
};

export const formatDateToDDMMMYYYY = (dateString: string): string => {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const date = new Date(dateString);
	const day = date.getDate();
	const month = months[date.getMonth()];
	const year = date.getFullYear();
	return `${day} ${month} ${year}`;
};

export const formatDateToDDMMYYYY = (dateString: string): string => {
	const date = new Date(dateString);
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	return `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}`;
};
